import { Capacitor } from '@capacitor/core';
import { PrivyProvider } from '@privy-io/react-auth';
import { useFlag } from '@unleash/proxy-client-react';

const WalletProvider = ({ children, appearance }) => {
  const loginWithWallets = useFlag('loginWithWallets');
  const usePrivyCapacitorClient = useFlag('usePrivyCapacitorClient');
  const privyClientId =
    Capacitor.isNativePlatform() && usePrivyCapacitorClient
      ? import.meta.env.VITE_PRIVY_CAPACITOR_CLIENT_ID
      : import.meta.env.VITE_PRIVY_WEB_CLIENT_ID;

  return (
    <PrivyProvider
      appId={import.meta.env.VITE_PRIVY_APP_ID}
      clientId={privyClientId}
      config={{
        loginMethods: Capacitor.isNativePlatform()
          ? ['email', 'sms']
          : loginWithWallets
            ? ['email', 'google', 'apple', 'sms', 'wallet']
            : ['email', 'google', 'apple', 'sms'],
        appearance: {
          walletChainType: 'solana-only',
          walletList: ['detected_wallets'],
          ...appearance,
        },
      }}
    >
      {children}
    </PrivyProvider>
  );
};

export default WalletProvider;
